import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { Container } from '../../view/FormBuilderStatusesView';
import InputBase from '../../form/InputBase';
import OTGreyCard from '../../containers/cards/OTGreyCard';
import useTranslations from '../../../hooks/useTranslations';
import Button from '../../Button';
import Colors from '../../../internal-components/Colors';
import Animation from '../../Animation';
import GeneralDialog from '../../../internal-components/GeneralDialog';
import AutomationsActionsEngine from '../engine/AutomationsActionsEngine';
import { AutomationsContex } from '../../engine/FormBuilderAutomationsEngine';
import ConditionsQueryBuilderEngine from '../../conditions-query-builder/engine/ConditionsQueryBuilderEngine';
import BackButton from '../../BackButton';
import AutomationsTriggerEngine from '../engine/AutomationsTriggerEngine';
import { Options } from '../../conditions-query-builder/view/ConditionsQueryBuilderView';

const H2 = styled.h2`
  margin: 0.8rem 0;
  font-size: 18px;
  font-weight: 500;

  ${({ $required }) =>
    $required &&
    `&:after {
    content:" *";
    color: red;
  }`}
`;
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 0 0 0;
`;

const ErrorMsg = styled.p`
  color: ${Colors.OT_RED};
  margin-top: 3px !important;
`;

const SectionContainerCSS = `
    margin-top: 0.8rem;
   
`;

const SectionContainer = props => {
  return <OTGreyCard $css={SectionContainerCSS} {...props} />;
};

const AutomationWizardView = props => {
  const t = useTranslations();
  const { data } = props;
  const { form } = useContext(AutomationsContex);
  return (
    <>
      <Container>
        <BackButton onClick={props.onCancel} size="small" />
        <SectionContainer>
          <H2 $required>{t('automations.wizard.title.title')} </H2>
          <InputBase
            error={props.titleError}
            value={t(data.label)}
            onChange={props.onTitleChange}
            variant="outlined"
            customCSS="input { font-size: 16px; }"
            data-testid="automation-title"
          />
          <Animation type="collapse" in={!!props.titleError.length}>
            <ErrorMsg>
              {t(`automations.wizard.title.error.${props.titleError}`)}
            </ErrorMsg>
          </Animation>
        </SectionContainer>
        <SectionContainer>
          <H2 $required>{t('automations.wizard.trigger.title')}</H2>
          <p>{t('automations.wizard.trigger.text')}</p>
          <AutomationsTriggerEngine
            trigger={
              data.rule.when.eventType === 'cb'
                ? data.rule.when.eventInfo
                : data.rule.when.eventType
            }
            onTriggerChange={props.onTriggerChange}
            setSchedulerPromise={promise =>
              props.dispatch({ type: 'update_promise', payload: promise })
            }
            schedulerData={props.schedulerData}
          />
        </SectionContainer>
        <SectionContainer>
          <H2>{t('automations.wizard.condition.title')}</H2>
          <p>{t('automations.wizard.condition.text')}</p>
          <ConditionsQueryBuilderEngine
            form={form}
            update={props.onLogicChange}
            backEndConditions={props.data.rule.condition}
            useSpacers
            filter={[Options.DATE_RANGE]}
          />
        </SectionContainer>
        <SectionContainer>
          <H2 $required>{t('automations.wizard.actions.title')}</H2>
          <p>{t('automations.wizard.actions.text')}</p>
          <AutomationsActionsEngine
            actions={
              data.rule.actionsList && !!data.rule.actionsList.length
                ? data.rule.actionsList
                : [data.rule.action]
            }
            updateResults={props.onActionsChange}
          />
        </SectionContainer>
        <ButtonsContainer>
          <Button variant="outlined" onClick={props.onCancel}>
            {t('automations.wizard.buttons.cancel')}
          </Button>
          <Button disabled={props.isSaveBtnDisabled()} onClick={props.onSave}>
            {t('automations.wizard.buttons.confirm')}
          </Button>
        </ButtonsContainer>
      </Container>
      <GeneralDialog
        // title={'automaions.wizard.dialog.title'}
        content={'automaions.wizard.dialog.content'}
        open={props.isDiscardChangesDialogOpen}
        handleClose={() => props.setIsDiscardChangesDialogOpen(false)}
        handleConfirm={() => {
          props.setIsDiscardChangesDialogOpen(false);
          props.onWizardClose();
        }}
        buttons={[
          { text: 'Yes', onClick: 'confirm' },
          { text: 'No', variant: 'outlined' }
        ]}
      />
    </>
  );
};

export default AutomationWizardView;
